import { StateType } from '../index';

export const getConsultantSelector = (state: StateType) => state.getIn(['consultant']);
